

import React from 'react';
import './App.css';
import MyRouter from './routes.jsx';
import { BrowserRouter } from 'react-router-dom';
import { MyProvider } from './MyContext.jsx';
import AutoLogout from './Auth/AutoLogout.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  
  return (
    <div>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <MyProvider>
            <AutoLogout>
              <MyRouter />
            </AutoLogout>
          </MyProvider>
        </BrowserRouter>
        <ToastContainer position="top-right" autoClose={15000} />
    </div>
    
  );
}

export default App;
